import { amber } from '@mui/material/colors';

export const MAX_CHARS = 1000;

export const reviewModalNotesStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		backgroundColor: amber[50],
		border: '1px solid',
		borderColor: 'divider',
		borderRadius: '4px',
		p: 2,
		width: '100%',
		gap: 0,
		position: 'relative',
		cursor: 'text'
	},

	requiredChip: {
		position: 'absolute',
		top: 8,
		right: 8
	},

	notesText: {
		fontSize: '0.875rem',
		fontWeight: 700,
		color: 'text.fadedPrimary',
		transition: 'height 200ms ease, min-height 200ms ease',
		'&&.MuiInputBase-input::placeholder': {
			fontWeight: 700,
			color: '#a5a192',
			opacity: 1
		}
	},

	notesTextCollapsed: {
		overflow: 'hidden !important',
		scrollbarWidth: 'none',
		'&::-webkit-scrollbar': {
			display: 'none'
		}
	},

	fieldWrapper: {
		position: 'relative',
		width: '100%'
	},

	fadeOverlay: {
		position: 'absolute',
		left: 0,
		right: 0,
		bottom: 0,
		height: '1.4em',
		pointerEvents: 'none',
		background: `linear-gradient(to bottom, rgba(255, 248, 225, 0) 0%, ${amber[50]} 100%)`
	}
};
